import { render, staticRenderFns } from "./DocCateEdit.vue?vue&type=template&id=ce2ee218&scoped=true"
import script from "./DocCateEdit.vue?vue&type=script&lang=js"
export * from "./DocCateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ee218",
  null
  
)

export default component.exports